// Shared vocabulary for who actually owns a piece of kit. Our own tools sit
// on the balance sheet; a customer's drill and a hired forklift do not, and
// both have to go back.
//
// The labels are localised, so every helper takes the caller's ``t``.
export const OWNERSHIP_VALUES = ['own', 'customer_provided', 'rented'];

export const ownershipOptions = (t) => OWNERSHIP_VALUES.map((value) => ({
  value,
  label: t(`inv.ownership.${value}.label`),
  short: t(`inv.ownership.${value}.short`),
}));

export const ownershipLabel = (v, t) =>
  t(`inv.ownership.${OWNERSHIP_VALUES.includes(v) ? v : 'own'}.label`);

export const ownershipShort = (v, t) =>
  t(`inv.ownership.${OWNERSHIP_VALUES.includes(v) ? v : 'own'}.short`);

// Badge tone: ours is quiet, borrowed is blue, hired is amber — so a list
// reads at a glance on site.
export const ownershipTone = (v) => ({
  own: 'bg-slate-100 text-slate-700 border-slate-200',
  customer_provided: 'bg-blue-50 text-blue-800 border-blue-200',
  rented: 'bg-amber-50 text-amber-900 border-amber-200',
}[v || 'own'] || 'bg-slate-100 text-slate-700 border-slate-200');

export const isBorrowed = (v) => v === 'customer_provided' || v === 'rented';

export const RATE_PERIOD_VALUES = ['day', 'week', 'month'];

export const ratePeriods = (t) => RATE_PERIOD_VALUES.map((value) => ({
  value, label: t(`inv.ownership.period.${value}`),
}));
